<template>
  <hic-list-page title="床位" :condition="condition" :entities="entities" @load="page" :loading="meta.loading"
    keyword-placeholder="床位号或住院号" show-model-switch card-box :card-model.sync="meta.cardModel" @cardModelChange="modelChange"
    exportable @export="download" :search-fields="searchFields" :hide-search-dialog="setting.isSimple">
    <template slot="buttons">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="create">新建</el-button>
    </template>
    <template slot="search">
      <el-cascader v-if="meta.cardModel" v-model="site" :options="options"
        :props="{ expandTrigger: 'hover', value: 'code', label: 'text', checkStrictly: true }" size="small" style="width: 18rem"
        placeholder="病房位置" clearable></el-cascader>
    </template>
    <el-table-column align="center" label="操作" width="100" key="iousCmd">
      <template slot-scope="{ row }">
        <el-button type="primary" title="编辑" size="mini" plain icon="el-icon-edit" circle @click="edit(row)"></el-button>
      </template>
    </el-table-column>
    <el-table-column v-if="!setting.isSimple" align="center" label="病区" prop="wardCode" :filters="dict.IpWard"
      :filter-multiple="false" column-key="wardCode">
      <template slot-scope="{ row }">
        <div>{{ row.wardCode | dictText("IpWard") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="left" label="科室" prop="deptCode" :filters="dict.Dept.filter((d) => d.ifIp)" :filter-multiple="false"
      column-key="deptCode">
      <template slot-scope="{ row }">
        <div>{{ row.deptCode | dictText("Dept") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="right" label="楼栋" prop="building" :filters="dict.Building" :filter-multiple="false"
      column-key="building">
      <template slot-scope="{ row }">
        <div>{{ row.building | dictText("Building") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="right" label="楼层" prop="floor"
      :filters="dict.Floor.filter((d) => !condition.building || !condition.building.length || d.parentCode === condition.building[0])"
      :filter-multiple="false" column-key="floor">
      <template slot-scope="{ row }">
        <div>{{ row.floor | dictText("Floor") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="right" label="病房" prop="room"
      :filters="dict.Room.filter((d) => !condition.floor || !condition.floor.length || d.parentCode === condition.floor[0])"
      :filter-multiple="false" column-key="room">
      <template slot-scope="{ row }">
        <div>{{ row.room | dictText("Room") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="right" label="床位号" prop="no"> </el-table-column>
    <el-table-column v-if="!setting.isSimple" align="center" label="类型" prop="type" width="100" :filters="dict.BedType"
      :filter-multiple="false" column-key="type">
      <template slot-scope="{ row }">
        <div>{{ row.type | dictText("BedType") }}</div>
      </template>
    </el-table-column>
    <el-table-column v-if="!setting.isSimple" align="center" label="加床" prop="ifExtra" width="80" :filters="$utils.Dict.bool()"
      :filter-multiple="false" column-key="ifExtra">
      <template slot-scope="{ row }">
        <el-tag v-if="row.ifExtra" type="success" size="mini" hit>是</el-tag>
      </template>
    </el-table-column>
    <el-table-column align="center" label="停用" prop="disabled" width="80" :filters="$utils.Dict.bool()" :filter-multiple="false"
      column-key="disabled">
      <template slot-scope="{ row }">
        <el-tag v-if="row.disabled" type="danger" size="mini" hit>是</el-tag>
      </template>
    </el-table-column>
    <el-table-column align="left" label="患者" prop="ipNo"></el-table-column>

    <el-row slot="box" style="padding: 1rem">
      <el-card v-for="building in buildings" :key="building.id" class="bottom-pad" shadow="hover">
        <el-row slot="header">
          <el-link v-if="!setting.isSimple" @click="dictEdit('Building', building.code)"><i class="el-icon-office-building" /> {{
            building.text }}</el-link>
          <b v-else class="primary"><i class="el-icon-school" /> {{ building.text }}</b>
          <el-link v-if="!setting.isSimple" @click="dictCreate('Building', building.code)" type="primary"
            icon="el-icon-circle-plus-outline" class="left-pad" :underline="false"></el-link>
        </el-row>
        <el-container v-for="floor in floors.filter((d) => d.parentCode === building.code)" :key="floor.id" class="bottom-pad"
          shadow="hover" style="border-bottom: solid 5px #ebeef5">
          <el-aside width="1rem" class="center right-pad bottom-pad">
            <span class="primary"> {{ floor.text }}</span>
            <el-link v-if="!setting.isSimple" type="primary" icon="el-icon-circle-plus-outline" class="top-pad"
              :underline="false"></el-link>
          </el-aside>
          <el-main>
            <el-col v-for="room in rooms.filter((r) => r.parentCode === floor.code)" :key="room.id" :span="6">
              <el-card shadow="hover" class="bottom-pad right-pad"
                body-style="padding:10px;min-height:130px;display:flex;flex-direction:column;align-items:center;justify-content:left;">
                <el-row class="center bottom-pad">
                  <el-link v-if="!setting.isSimple"><i class="el-icon-table-lamp" /> {{ room.text }}</el-link>
                  <span v-else> {{ room.text }}</span>
                  <el-link type="primary" icon="el-icon-circle-plus-outline" class="left-pad" style="font-size: 1.2rem"
                    :underline="false" @click="create(building.code, floor.code, room.code)"></el-link>
                </el-row>
                <el-button v-for="bed in entities.items.filter((b) => b.room == room.code)" :key="bed.id"
                  :type="bed.ipNo ? 'info' : bed.disabled ? 'danger' : 'success'" class="left bottom-pad f-w"
                  style="padding: 5px; margin-left: 0" @click="edit(bed)" plain>
                  <b><i v-if="bed.disabled" class="el-icon-folder-delete" /><i v-else-if="bed.ifExtra"
                      class="el-icon-folder-add" /><i v-else-if="bed.ipNo" class="el-icon-folder-checked" /><i v-else
                      class="el-icon-folder" /> {{ bed.no }}</b>
                  <span type="info" size="mini" class="left-pad" style="line-height: 20px">{{ bed.type | dictText("BedType")
                  }}</span>
                  <el-tag v-if="bed.ifExtra" type="warning" size="mini" hit class="left-pad">加</el-tag>
                  <el-tag v-if="bed.disabled" type="danger" size="mini" hit class="left-pad">停</el-tag>
                  <i v-if="bed.ipNo" class="el-icon-user-solid left-pad" :title="bed.ipNo" />
                  <i v-else class="el-icon-user left-pad" />
                  <span type="info" size="mini" class="left-pad">{{ bed.deptCode | dictText("Dept") }}</span>
                </el-button>
              </el-card>
            </el-col>
          </el-main>
        </el-container>
      </el-card>
    </el-row>
    <el-row slot="footer" v-if="meta.cardModel">
      <span>床位总数：{{ entities.items.length }}</span>
    </el-row>
    <Editor :value="entity" :visible.sync="meta.editorShow" @saved="page" />
    <DictEditor :value="dictEntity" :visible.sync="meta.dictEditorShow" @saved="page" />
  </hic-list-page>
</template>
<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  components: {
    Editor: () => import("./edit"),
    DictEditor: () => import("./dictEditor"),
  },
  data() {
    return {
      meta: {
        editorShow: false,
        dictEditorShow: false,
        cardModel: true,
        loading: false,
      },
      condition: {
        sort: "no",
        asc: true,
        keyword: null,
        pageSize: 999999,
        pageIndexOnView: 1,
      },
      entities: { items: [] },
      entity: {},
      dictEntity: {},
      site: [],
    };
  },
  computed: {
    ...mapGetters(["dict", "user", "setting"]),
    options() {
      let list = [];
      list.push(...this.dict.Building);
      list.push(...this.dict.Floor);
      list.push(...this.dict.Room);
      return this.$utils.Cascade.make(list);
    },
    buildings() {
      return this.dict.Building.filter((b) => !this.site[0] || b.code == this.site[0]);
    },
    floors() {
      return this.dict.Floor.filter((f) => !this.site[1] || f.code == this.site[1]);
    },
    rooms() {
      return this.dict.Room.filter((r) => !this.site[2] || r.code == this.site[2]);
    },
    searchFields() {
      return [
        { label: "病区", prop: "wardCode", type: "dict", options: this.dict.IpWard },
        { label: "科室", prop: "deptCode", type: "dict", options: this.dict.Dept },
        { label: "楼栋", prop: "building", type: "dict", options: this.dict.Building },
        { label: "楼层", prop: "floor", type: "dict", options: this.dict.Floor },
        { label: "病房", prop: "room", type: "dict", options: this.dict.Room },
        { label: "床位号", prop: "no", type: "input" },
        { label: "床位类型", prop: "bedType", type: "dict", options: this.dict.BedType },
        { label: "临时加床", prop: "ifExtra", type: "dict", options: this.$utils.Dict.bool() },
        { label: "停用状态", prop: "disabled", type: "dict", options: this.$utils.Dict.bool() },
        { label: "住院号", prop: "ipNo", type: "input" },
      ];
    },
  },
  methods: {
    page() {
      this.meta.loading = true;
      api.Bed.query(this.condition)
        .then((res) => {
          this.entities = res;
        })
        .catch((err) => {
          this.$message.error(err.message || err);
        })
        .finally(() => {
          this.meta.loading = false;
        });
    },
    download() {
      api.Bed.export(this.condition, "住院床位.xls", [
        { property: "wardCode", title: "病区", dict: this.dict.IpWard },
        { property: "deptCode", title: "科室", dict: this.dict.Dept },
        { property: "building", title: "楼栋", dict: this.dict.Building },
        { property: "floor", title: "楼层", dict: this.dict.Floor },
        { property: "room", title: "病房", dict: this.dict.Room },
        { property: "no", title: "床位号" },
        { property: "type", title: "床位类型", dict: this.dict.BedType },
        { property: "ifExtra", title: "临时加床", dict: this.$utils.Dict.bool() },
        { property: "disabled", title: "停用状态", dict: this.$utils.Dict.bool() },
        { property: "ipNo", title: "患者住院号" },
      ]);
    },
    create(building, floor, room) {
      this.entity = { building, floor, room, deptCode: this.setting.isSimple ? this.user.deptCode : null };
      this.meta.editorShow = true;
    },
    edit(row) {
      this.entity = this.$utils.Obj.clone(row);
      this.meta.editorShow = true;
    },
    dictCreate(type, code) {
      if (type == "Building") {
        this.dictEntity = {
          type: "Floor",
          parentCode: code,
        };
        this.meta.dictEditorShow = true;
      }
    },
    dictEdit(type, code) { },
    modelChange() {
      if (this.meta.cardModel) {
        this.condition.pageSize = 999999;
        this.condition.pageIndexOnView = 1;
      } else {
        this.condition.pageSize = 20;
      }
      this.page();
    },
  },
};
</script>
